import { LongText } from '@dfl/mui-react-common';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

type TranslateLabelProps = {
  label: string;
  className?: string;
  locale?: string;
};

const TranslateLabel = ({ label, locale = 'common', className }: TranslateLabelProps) => {
  const { t } = useTranslation(locale);
  return (
    <LongText
      lineClamp={1}
      text={t(label || '')}
      className={className}
      sx={(theme) => ({
        paddingRight: 0.5,
        color: theme.palette.mode === 'dark' ? theme.palette.grey[400] : theme.palette.grey[700],
      })}
    />
  );
};

export default memo(TranslateLabel);
